import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { twMerge } from 'tailwind-merge';
import { passwordValidation } from '../../../utils/validations';

const PasswordInput = ({ id, label, name, disabled, placeholder, className }) => {
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <label className="input-label">{label}</label>
      <div className="relative w-full">
        <div
          className="absolute inset-y-0 right-4 flex items-center pl-3 cursor-pointer z-10"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <AiFillEyeInvisible size="20" className="text-icons" />
          ) : (
            <AiFillEye size="20" className="text-icons" />
          )}
        </div>
        <input
          id={id}
          disabled={disabled}
          type={showPassword ? 'input' : 'password'}
          name={name}
          autoComplete="off"
          placeholder={placeholder}
          className={twMerge('input', className)}
          {...register(name, passwordValidation)}
        />
      </div>
      {errors[name] && <span className="text-xs text-contrast1 mt-1">{errors[name].message}</span>}
    </div>
  );
};

export default PasswordInput;
